import { useCallback, useState } from 'react'

/**
 * State hook which works like class component this.setState
 *
 * Based on react-use package
 * https://github.com/streamich/react-use/blob/3685b7502a4d1980953deed11c3dee31b220c89d/src/useSetState.ts
 */
export function useSetState<T extends object>(
	initialState: T | (() => T)
): [T, (patch: Partial<T> | ((prevState: T) => Partial<T>)) => void] {
	const [state, set] = useState<T>(initialState)

	const setState = useCallback((patch) => {
		set((prevState) => ({
			...prevState,
			...(patch instanceof Function ? patch(prevState) : patch),
		}))
	}, [])

	return [state, setState]
}
